<template>
    <div style="width: 100%;height: 400px;background-color: lightblue">
        {{title}}
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>
